<template>
  <div class="section-main__warp visitor-wrap">
    <!--数据表格-->
    <ioc-table :option="tableColumns" :data="tableData" :loading="tableLoading" :page="page"
      @current-change="pageNoChange" @size-change="pageSizeChange" @refresh-change="refreshChange"
      @selection-change="handleSelectionChange" @search-change="handleSearchChange" @search-reset="refreshChange">
      <template slot="search_createTime">
        <div>
          <el-date-picker @change="handleTimeChange" type="datetimerange" v-model="searchTime" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          <!-- <el-date-picker
            type="datetime"
            placeholder="请选择开始时间"
            v-model="searchParams.beginTime"
            default-time="00:00:00"
            style="width: 182px"
          ></el-date-picker>
          <span style="padding: 0 5px">至</span>
          <el-date-picker
            type="datetime"
            placeholder="请选择结束时间"
            v-model="searchParams.endTime"
            default-time="23:59:59"
            style="width: 182px"
          ></el-date-picker> -->
        </div>
      </template>
      <template slot="menuLeft">
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </template>
      <!-- <template #actualVisitTime="{ row }">
        {{
          row.startTime && row.endTime
            ? getDateStr(row.startTime, "YYYY-MM-DD hh:mm:ss") +
              "~" +
              getDateStr(row.endTime, "YYYY-MM-DD hh:mm:ss")
            : "暂无"
        }}
      </template> -->
      <!-- <template #enterTime="{ row }">
        {{ row.enterTime }}~ {{ row.exitTime }}
      </template> -->
      <!--操作项-->
      <template slot="menu" slot-scope="scope">
        <!-- <el-tooltip
          class="item"
          effect="dark"
          content="修改"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-xiugai"
            @click="handleEdit(scope.row, scope.index)"
          ></el-button>
        </el-tooltip> -->
        <el-tooltip class="item" effect="dark" content="详情" placement="top" popper-class="tooltip-draw">
          <el-button type="text" icon="iconfont icon-Detail" @click="handleView(scope.row, scope.index)"></el-button>
        </el-tooltip>
        <!-- v-if="
            scope.row.enterStatus !== '1' &&
            (scope.row.status === '6' ||
              scope.row.status === '7' ||
              scope.row.status === '99')
          " -->
        <el-tooltip v-if="scope.row.enterStatus !== '1' &&
          (scope.row.status === '6' ||
            scope.row.status === '7' ||
            scope.row.status === '99')
          " class="item" effect="dark" content="再次预约" placement="top" popper-class="tooltip-draw">
          <el-button type="text" icon="el-icon-circle-plus-outline"
            @click="applyAgain(scope.row, scope.index)"></el-button>
        </el-tooltip>
        <el-tooltip v-if="scope.row.enterStatus !== '1' &&
          (scope.row.status === '6' ||
            scope.row.status === '7' ||
            scope.row.status === '99')
          " class="item" effect="dark" content="延时" placement="top" popper-class="tooltip-draw">
          <el-button type="text" icon="icon iconfont-add iconyanshi" @click="delay(scope.row, 1)"></el-button>
        </el-tooltip>
        <el-tooltip v-if="scope.row.status === '7'" class="item" effect="dark" content="签离" placement="top"
          popper-class="tooltip-draw">
          <el-button type="text" icon="el-icon-thumb" @click="delay(scope.row, 2)"></el-button>
        </el-tooltip>
        <!-- <app-button
								v-if="data.enterStatus !== '1' && (data.status === '6' || data.status === '7' || data.status === '99')"
								size="smaller" type="primary" @click="applyAgain(data)">再次预约</app-button> -->
        <!-- <el-tooltip
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-shanchu"
            @click="handleDelete(scope.row, scope.index)"
          ></el-button>
        </el-tooltip> -->
      </template>
    </ioc-table>

    <!-- </soc-data> -->
    <invitation-info-component ref="invitationInfo" v-if="visible" @handleCancel="handleCancel" />
    <add-invitation-component ref="addRef" @handleCancel="handleAddCancel" @getList="queryData" />
    <detail-dialog ref="detailDialog"></detail-dialog>
    <delay-dialog ref="delayDialog" @delayOk="queryData"></delay-dialog>
  </div>
</template>

<script>
import delayDialog from "../components/delayDialog";
import InvitationInfoComponent from "../components/invitationInfoComponent";
import AddInvitationComponent from "../components/addInvitationComponent";
import utils from "@src/common/utils";
// import tableOption from '../../account/const/crud/account';
import tableOption from "../const/invitation.js";
import detailDialog from "../components/details-dialog";
import { Cache } from "@src/common/utils";
import { api } from "../api.js";
// import { getDateStr } from "@/common/utils";
export default {
  name: "invitation",
  components: {
    AddInvitationComponent,
    InvitationInfoComponent,
    detailDialog,
    delayDialog,
  },
  data() {
    return {
      visible: false,
      addVisible: false,
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      searchParams: {
        name: "",
        enterTime: "",
        exitTime: "",
      },
      checkedData: [],
      tableLoading: false,
      statusData: [
        { label: "全部任务", value: "" },
        { label: this.$t("electronic.resultDes1"), value: "1" },
        { label: this.$t("electronic.resultDes2"), value: "2" },
        { label: this.$t("electronic.resultDes3"), value: "3" },
        { label: this.$t("electronic.resultDes4"), value: "4" },
      ],
      overdueList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "是",
          value: "1",
        },
        {
          label: "否",
          value: "2",
        },
      ],
      appointmentDates: [],
      visitDates: [],
      params: {
        pageNum: 1,
        pageSize: 10,
      },
      pageNo: 1,
      pageSize: 20,
      total: 0,
      importExlParams: {},
      tableData: [],
      tableColumns: tableOption(),
      searchTime: [],
    };
  },
  mounted() {
    this.queryData();
    // this.handleSearch();
  },
  methods: {
    handleTimeChange(data) {
      console.log(data, ">>>>>data");
      if (data && data.length > 0) {
        this.searchParams.beginTime = data[0];
        this.searchParams.endTime = data[1];
      }
    },
    delay(row, type) {
      this.$refs.delayDialog.open(row, type);
      console.log(row, ">>>>>row");
    },

    getDateStr(date, format) {
      return date ? utils.Dates.dayjs(data).format(format) : "暂无";
    },

    handeAppointmentChange(data) {
      this.params.appointmentStartDate = data[0];
      this.params.appointmentEndDate = data[1];
      console.log(data, "====data");
    },

    handeVisitChange(data) {
      this.params.beginTime = data[0];
      this.params.endTime = data[1];
      console.log(data, "====data");
    },
    handleEdit(row) {
      this.$refs.addRef.openPanel("edit", row);
    },
    handleDelete(row) {
      this.$confirm("确定删除该条拜访数据吗？", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let param = {
          appointmentCode: row.appointmentCode,
        };
        this.$fetch(api.deleteVisitorApply).then((res) => {
          if (!res.success) {
            this.$message.error(res.msgContent);
            return;
          }
        });
      });
    },
    handleView(row) {
      console.log("row", row);
      let param = {
        appointmentCode: row.appointmentCode,
      };
      this.$fetch(api.queryVisitorDetail, param).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        this.$refs.detailDialog.open(row.appointmentCode);
        // this.$refs.addRef.openPanel("detail", res.returnObj);
      });
    },
    handleAdd() {
      this.$refs.addRef.openPanel("add");
    },
    applyAgain(row) {
      let param = {
        appointmentCode: row.appointmentCode,
      };
      this.$fetch(api.queryVisitorDetail, param).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        this.$refs.addRef.openPanel("again", res.returnObj);

        // this.$refs.addRef.openPanel("detail", res.returnObj);
      });
    },
    handleCancel() {
      this.visible = false;
    },
    handleAddCancel() {
      this.addVisible = false;
    },
    /**
     * 记录信息查询
     */
    queryData() {
      this.tableLoading = true;
      let firstBeginTime = "";
      let lastEndTime = "";
      let accountNumber = Cache.get("CACHE_USER_INFO").account;
      console.log(accountNumber, ">>>>>account");
      const param = {
        ...this.params,
        ...this.searchParams,
        accountNumber,
      };
      // this.importExlParams = JSON.parse(JSON.stringify(param))
      this.$fetch(api.getVisitorMyApplyList, param).then((res) => {
        this.tableLoading = false;
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        if (!res.returnObj) {
          return;
        }
        const _data = res.returnObj;
        this.tableData = _data.list;
        this.page.currentPage = _data.pageNum;
        this.page.pageSize = _data.pageSize;
        this.page.total = _data.total;
        console.log(this.total, this.tableData, "====tottaol");
      });
    },
    refreshChange(page) {
      console.log("重置");
      this.searchParams = {};
      this.searchTime = [];
      this.queryData(page);
    },
    handleSearchChange(param) {
      let tempObj = {};
      tempObj.beginTime = this.searchParams.beginTime;
      tempObj.endTime = this.searchParams.endTime;
      this.searchParams = Object.assign({}, param);
      this.searchParams.beginTime = tempObj.beginTime;
      this.searchParams.endTime = tempObj.endTime;
      this.queryData();
    },
    // handleSearchChange(param) {
    //   this.searchParams.name = param.name;

    //   this.queryData();
    // },
    handleSelectionChange(items) {
      // this.checkedAccounts = items.map((item) => {
      //   return item.workGroupCode;
      // });
    },
    /**
     * 表格选中回调
     * @param val 选中值 array
     */
    changeSelection(val) {
      this.checkedData = val;
    },
    /**
     * 每页记录数改变触发
     * @param pageSize 记录值
     */
    pageSizeChange(pageSize) {
      this.params.pageSize = pageSize;
      this.queryData();
    },
    /**
     * 当前页改变触发
     * @param pageNo 当前页码
     */
    pageNoChange(pageNo) {
      this.params.pageNum = pageNo;
      this.queryData();
    },
  },
};
</script>

<style lang="scss" scoped>
.alarm_options {
  display: flex;
  flex-direction: row;

  .options_icon {
    font-size: 20px;
    margin-right: 10px;
    cursor: pointer;

    // &:hover {
    //   // @include set_primary_theme(color);
    // }
  }
}
</style>
<style lang="scss">
.el-radio__input.is-checked+.el-radio__label {
  color: black !important;
}

.el-icon-circle-plus-outline,
.icon-Detail,
.el-icon-thumb {
  font-size: 16px;
}
</style>
